// extracted by mini-css-extract-plugin
export default {"clamped_text":"styles_clamped_text__eq3aQ"};